import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { throwError } from "rxjs";

import { NotificationMessageService } from "../services/notification.message.service";
export const networkInterceptor: HttpInterceptorFn = (req, next) => {
  const messages = inject(NotificationMessageService);
  const translation = inject(TranslateService);

  if (!window.navigator.onLine) {
    const errorMessage = translation.instant("NO_INTERNET_CONNECTION");
    messages.showErrorMessage(errorMessage);
    return throwError(() => errorMessage);
  }
  return next(req);
};
